import { type FetchNftMyCollectiblesV2Params, getHttpClient, NftApi } from '@capsicum/common';

export const nftApi = getHttpClient.then(client => new NftApi(client));

export async function fetchMyNfts(params?: FetchNftMyCollectiblesV2Params) {
	return (await nftApi)
		.fetchNftMyCollectiblesV2({
			'statuses[]': ['minted'],
			...params
		})
		.then(res => res.data);
}
